import React, { useEffect, useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useAlert } from "react-alert";
import { useDropzone } from 'react-dropzone'
import styled from 'styled-components';
import { confirmAlert } from "react-confirm-alert";

export default function InitialMessageContainer() {
    let alert = useAlert();
    const [value, setValue] = useState('.');
    const [nametitular, setnametitular] = useState();
    const [textlink, settextlink] = useState();

    var modules = {
        toolbar: [
            [{ 'header': [1, 2, 3, false] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
            ['link', 'image'],
            ['clean'], [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }]
        ],
    }

    var formats = [
        'header', 'align',
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet', 'indent',
        'link', 'image'
    ]

    const saveTitularPhoto = (file) => {
        const formData = new FormData();

        formData.append(`initialmessage`, file[0]);

        fetch(`${process.env.REACT_APP_URL_API}/data/saveTitularPhoto`, {
            method: "POST",
            mode: "cors",
            headers: {
                "Cache-Control": "no-cache",
                "Access-Control-Allow-Origin": "*",
            },
            body: formData,
        })
            .then((response) => response.json())
            .then((datar) => {
                if (datar.rows > 0) {
                    alert.show("Foto Guardada", {
                        timeout: 3000,
                        type: "success"
                    });
                }
            })
            .catch((error) => {
                alert.show(
                    "Ocurrió un error al agregar la foto del titular:" +
                    error,
                    {
                        timeout: 3000,
                        type: "error",
                    }
                );
            });
    }

    const saveInitialMessage = () => {
        fetch(`${process.env.REACT_APP_URL_API}/data/saveInitialMessage`, {
            method: "POST",
            mode: "cors",
            headers: {
                "Cache-Control": "no-cache",
                "Access-Control-Allow-Origin": "*",
            },
            body: JSON.stringify({ value, nametitular, textlink }),
        })
            .then((response) => response.json())
            .then((datar) => {
                if (datar.rows > 0) {
                    alert.show("Datos Guardados", {
                        timeout: 3000,
                        type: "success",
                        onClose: () => {
                            window.location.reload();
                        },
                    });
                }
            })
            .catch((error) => {
                alert.show(
                    "Ocurrió un error al agregar la foto del titular:" +
                    error,
                    {
                        timeout: 3000,
                        type: "error",
                    }
                );
            });
    }

    useEffect(() => {
        getInitialMessage()
    }, [])

    const getInitialMessage = (date) => {
        fetch(
            `${process.env.REACT_APP_URL_API}/data/getInitialMessage`,
            {
                method: "GET",
                mode: "cors",
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-cache",
                    "Access-Control-Allow-Origin": "*",
                },
            }
        )
            .then((response) => response.json())
            .then((data) => {
                var initialmessagepush = []
                data.map(initialmessage => {
                    initialmessagepush.push({
                        id: initialmessage.idinitialmessage,
                        file: [{ preview: initialmessage.preview }]
                    })

                    setnametitular(initialmessage.nametitular || "");
                    settextlink(initialmessage.textlink || "");
                    setValue(initialmessage.content || ".")
                });

                setFiles(initialmessagepush);
            })
            .catch((error) => {
                alert.show("Ocurrió un error al obtener los datos del Mensaje", {
                    timeout: 3000,
                    type: "error",
                });
            });
    }

    const [files, setFiles] = useState([]);

    const Container = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    border-width: 2px;
    border-radius: 2px;
    border-color: red;
    border-style: dashed;
    background-color: #fafafa;
    color: #bdbdbd;
    outline: none;
    transition: border .24s ease-in-out;
    `;

    const thumbInner = {
        width: '400px',
        padding: '25px',
        border: "1px #011b6c solid",
        borderRadius: "5px"
    };

    const img = {
        width: '300px',
        height: '200px'
    };

    function StyledDropzone(props) {
        const {
            getRootProps,
            getInputProps,
            isFocused,
            isDragAccept,
            isDragReject
        } = useDropzone({
            accept: { 'image/*': [] }, onDrop: acceptedFiles => {
                acceptedFiles.map(file => Object.assign(file, {
                    preview: URL.createObjectURL(file)
                }))

                saveTitularPhoto(acceptedFiles);

                setFiles(...files.push({
                    id: 0, file: acceptedFiles.map(file => Object.assign(file, {
                        preview: URL.createObjectURL(file)
                    }))
                }));

            }
        });

        const deleteImage = (index, id) => {
            confirmAlert({
                customUI: ({ onClose }) => {
                    return (
                        <div className="AlertUI">
                            <h1>Aviso</h1>
                            <p>
                                ¿Deseas eliminar la foto del titular?
                            </p>
                            <button onClick={onClose}>No</button>
                            <button
                                onClick={() => {
                                    setFiles(files.filter((item, ind) => (ind !== index)));
                                    onClose();
                                }}
                            >
                                Si
                            </button>
                        </div>
                    );
                },
            });
        }

        const thumbs = files.map((file, index) => (
            <div key={index}>
                <div style={thumbInner} className="ImageBackground">
                    <div className="row text-center">
                        <div className="col-md-12">
                            <img
                                src={file.file[0].preview}
                                style={img}
                                className='img-fluid'
                                alt='Upper File'
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <button className='btn btn-danger mt-4 form-control' onClick={() => deleteImage(index, file.idetic)}>Eliminar</button>
                        </div>
                    </div>
                </div>
            </div>
        ));

        return (
            <div className="container">
                {files.length == 0 && <Container {...getRootProps({ isFocused, isDragAccept, isDragReject })}>
                    <input {...getInputProps()} />
                    <p>Arrastra o da clic para subir los archivos (Uno por uno)</p>
                </Container>}
                <aside className='CalendarContainer pt-4' style={{ justifyContent: "center" }}>
                    {thumbs}
                </aside>
            </div>
        );
    }

    return (
        <>
            <div className="row">
                <p className='text-center'>Agrega o modifica el mensaje inicial</p>
            </div>
            <StyledDropzone />
            <button className="btn btn-success mb-2" onClick={() => {
                saveInitialMessage()
            }}>Guardar</button>
            <div className="row pb-2">
                <div className="col-6">
                    <label htmlFor="">Nombre</label>
                    <input type="text" className="form-control" value={nametitular} onChange={(e) => {
                        setnametitular(e.target.value);
                    }} />
                </div>
                <div className="col-6">
                    <label htmlFor="">Texto</label>
                    <input type="text" className="form-control" value={textlink} onChange={(e) => {
                        settextlink(e.target.value);
                    }} />
                </div>
            </div>
            {value && <ReactQuill theme="snow" value={value} modules={modules}
                formats={formats} onChange={setValue} />}
        </>
    )
}
